Ext.define('SA.model.createimport.ColumnNameValidator', {
    constructor(list) {
        this.list = list;
    },

    getFriendlyNameDefaultedNameConflicts() {
        var toLowerCase = name => name.toLowerCase(),
            defaultedNames = this.list.getDefaultedNames().map(toLowerCase),
            friendlyNames = this.list.getFriendlyNames().map(toLowerCase),
            doesConflict = name => friendlyNames.includes(name);

        return defaultedNames.filter(doesConflict);
    },

    hasDuplicateFriendlyNames() {
        var duplicates = new Set(),
            names = this.list.getFriendlyNames().map(name => name.toLowerCase()),
            defaultedNameConflicts = this.getFriendlyNameDefaultedNameConflicts(),
            isDuplicate = name => names.indexOf(name) !== names.lastIndexOf(name),
            isNotConflicted = name => !defaultedNameConflicts.includes(name),
            getDuplicatesArray = () => [...duplicates].filter(isNotConflicted);

        names.forEach(name => {
            if (isDuplicate(name)) {
                duplicates.add(name);
            }
        });

        return !!getDuplicatesArray().length;
    },

    hasFriendlyNameDefaultedNameConflicts() {
        return !!this.getFriendlyNameDefaultedNameConflicts().length;
    }
});